/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import EncountersidEncounter from './EncountersidEncounter';

/**
 * The EncountersIdBody model module.
 * @module model/EncountersIdBody
 * @version v0.3
 */
export default class EncountersIdBody {
  /**
   * Constructs a new <code>EncountersIdBody</code>.
   * @alias module:model/EncountersIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EncountersIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EncountersIdBody} obj Optional instance to populate.
   * @return {module:model/EncountersIdBody} The populated <code>EncountersIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EncountersIdBody();
      if (data.hasOwnProperty('encounter'))
        obj.encounter = EncountersidEncounter.constructFromObject(data['encounter']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EncountersidEncounter} encounter
 */
EncountersIdBody.prototype.encounter = undefined;

